import { useRef } from "react";
import { useIntl } from "react-intl";
import { useDispatch, useSelector } from "react-redux";

//Components
import { Input, Select, Button, Form } from "@gpstrackit/react-controls";
import { Chip, Grid } from "@mui/material";
import CustomCard from 'Components/Card';

//Actions
import { assignFirmwareSetDevices, clearRedux } from 'Redux/actions';
const StepOne = (props) => {
    const { entity, entityHandler, setSerial, serial, getDevice, account } = props;
    const dispatch = useDispatch();
    const { messages } = useIntl();

    const formRef = useRef();

    const { selectedCameras, allCameras, groupingByHarwareVersion } = useSelector(state => state.assignFirmwareDeviceRedux);

    let options = [
        {
            id: "all",
            name: messages['assign_firmware_all_devices']
        },
        {
            id: "entities",
            name: messages['assign_firmware_devices']
        },
        {
            id: "hardwareVersion",
            name: messages['assign_firmware_hardware_version']
        }
    ]

    return (
        <div>
            {
                account?.id ? (
                    <div>
                        {
                            options.map((item, key) => {
                                return (
                                    <Chip
                                        key={key}
                                        onClick={(() => entityHandler(item))}
                                        style={{
                                            marginRight: 5,
                                            cursor: 'pointer',
                                            backgroundColor: item?.id === entity?.id ? '#1D2734' : "#00000014",
                                            color: item?.id === entity?.id ? 'white' : "#000000de"
                                        }}
                                        label={item?.name}
                                    />
                                )
                            })
                        }
                    </div>
                ) : <></>
            }
            {
                entity?.id === "all" &&
                <p style={{ marginTop: 10, opacity: 0.5 }}>{messages['assign_firmware_label_all_devices']}.</p>
            }
            {
                entity?.id === "entities" &&
                <div style={{ marginTop: 10 }}>
                    <Grid container spacing={1}>
                        <Grid item xs={10}>
                            <Form ref={formRef} onValidSubmit={() => getDevice()}>
                                <Input
                                    id="serial-cameras"
                                    label={messages['assign_firmware_serial']}
                                    placeholder={messages['assign_firmware_serial']}
                                    value={serial}
                                    onChange={(value) => setSerial(value)}
                                    required
                                    requiredMessage={messages['required_field']}
                                />
                            </Form>
                        </Grid>
                        <Grid item xs={2} style={{ marginTop: 25 }}>
                            <Button
                                className="btn-dark-blue"
                                onClick={(e) => {
                                    e.preventDefault();
                                    formRef.current.submit()
                                }}
                                style={{ height: 43 }}
                            >
                                {messages['common_add']}
                            </Button>
                        </Grid>
                        <Grid item xs={12} style={{ marginTop: 5 }}>
                            {selectedCameras?.length ? selectedCameras.map((item, index) => {
                                return (
                                    <CustomCard
                                        key={item?.id}
                                        onClick={() => {
                                            let currentDevices = [...selectedCameras];
                                            let selected = currentDevices.findIndex((device) => device.id === item.id);
                                            if (selected > -1) currentDevices.splice(selected, 1);
                                            dispatch(assignFirmwareSetDevices(currentDevices));
                                        }}
                                    >
                                        <div style={{ display: 'grid' }}>
                                            <div>
                                                <label style={{ fontWeight: 700, marginRight: 5 }}>{messages['assign_firmware_device_name']}</label><span>{item?.label}</span>
                                            </div>
                                            <div>
                                                <label style={{ fontWeight: 700, marginRight: 5 }}>{messages['assign_firmware_serial']}</label><span>{item?.esn}</span>
                                            </div>
                                            <div>
                                                <label style={{ fontWeight: 700, marginRight: 5 }}>{messages['assign_firmware_hardware_version']}</label><span>{item?.unitConfig?.hardwareVersion || messages['assign_firmware_not_specified']}</span>
                                            </div>
                                            <div>
                                                <label style={{ fontWeight: 700, marginRight: 5 }}>{messages['assign_firmware_model']}</label><span>{item?.deviceModel?.name}</span>
                                            </div>
                                        </div>
                                    </CustomCard>
                                )
                            }) : <></>}
                        </Grid>
                    </Grid>
                </div>
            }
            {
                entity?.id === "hardwareVersion" &&
                <div style={{ marginTop: 10 }}>
                    <Select
                        id="hardware-version-list"
                        value={groupingByHarwareVersion}
                        options={allCameras || []}
                        label={messages['assign_firmware_hardware_version']}
                        required
                        requiredMessage={messages['required_field']}
                        onChange={(value) => {
                            dispatch(clearRedux("ASSIGN_FIRMWARE", { groupingByHarwareVersion: value }));
                        }}
                        valueField="hardwareVersion"
                        textField="hardwareVersion"
                        placeholder={messages['assign_firmware_hardware_version']}
                        multiple
                    />
                </div>
            }
        </div>
    )
}

export default StepOne